<script setup lang="ts">
import { computed } from 'vue';
import ButtonIcon from '../button-icon/index.vue';
import SvgIcon from '../svg-icon/index.vue';

defineOptions({ name: 'LangSwitch' });

interface Props {
  /** Current language */
  lang: string;
  /** Language options */
  langOptions: Array<{ key: string; label: string }>;
  /** Show tooltip */
  showTooltip?: boolean;
  /** Tooltip content for language switch */
  tooltipContent?: string;
}

const props = withDefaults(defineProps<Props>(), {
  showTooltip: true,
  tooltipContent: 'Switch Language'
});

type Emits = {
  (e: 'changeLang', lang: string): void;
};

const emit = defineEmits<Emits>();

const displayTooltipContent = computed(() => {
  if (!props.showTooltip) return '';
  return props.tooltipContent;
});

function changeLang(lang: string) {
  emit('changeLang', lang);
}
</script>

<template>
  <ElDropdown trigger="click">
    <div>
      <ButtonIcon :tooltip-content="displayTooltipContent" tooltip-placement="left">
        <slot>
          <SvgIcon icon="heroicons:language" />
        </slot>
      </ButtonIcon>
    </div>
    <template #dropdown>
      <ElDropdownMenu>
        <ElDropdownItem
          v-for="{ key, label } in langOptions"
          :key="key"
          :value="key"
          class="mx-4px my-1px"
          :class="{ 'is-active': key === lang }"
          @click="changeLang(key)"
        >
          {{ label }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<style scoped>
:deep(.el-dropdown-menu__item) {
  border-radius: 6px;
}
:deep(.is-active) {
  background-color: var(--el-dropdown-menuItem-hover-fill);
  color: var(--el-dropdown-menuItem-hover-color);
}
</style> 